import React from 'react';
import PropTypes from 'prop-types';

import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';

import { Section } from '../Section';
import { Select } from '../Select';

import { InputWrapper } from './styles';

export const OpportunityYearSection = ({
	opportunityYear,
	animationIndex,
	onChange,
}) => {
	return (
		<Section title="Plan/Execute Year" animationIndex={animationIndex}>
			<SettingsOptionsContext.Consumer>
				{({ options }) => {
					const financialYears =
						options && options.dateRanges
							? options.dateRanges
									.filter(item => !!item.year)
									.map(item => item.name)
							: [];

					return (
						<InputWrapper>
							<Select
								label={'Calendar Year'}
								name={'opportunityyear'}
								options={financialYears}
								value={opportunityYear}
								onChange={event => {
									onChange({ opportunityYear: event.target.value });
								}}
							/>
						</InputWrapper>
					);
				}}
			</SettingsOptionsContext.Consumer>
		</Section>
	);
};

OpportunityYearSection.propTypes = {
	opportunityYear: PropTypes.string.isRequired,
	animationIndex: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
};
